// extracted by mini-css-extract-plugin
module.exports = {"pageTopBarPreview":"jgp-1NJ8p","fullScreenWrapper":"jgp-3YL9C"};